import type { Store } from 'effector'

import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'
import { $statusChecksCount, $verificationTypeTranslation } from './model'

const $defaultReason: Store<string> = combine(i18n.$t, ({ t }) =>
  t('waiting_email_confirmation_default_message')
)

export const $waitingEmailConfirmationTranslations = combine(
  {
    i18n: i18n.$t,
    statusChecksCount: $statusChecksCount,
    defaultReason: $defaultReason,
  },
  ({ i18n: { t }, statusChecksCount, defaultReason }) => {
    // This calculation will change message in button after backend return WAITING_CONFIRMATION_EMAIL status
    // and during attempts to auto login in application
    // According `MAX_REGISTRATION_CHECKS` in `./model` file we get max checks count then change messages
    // after some period of time that calculated with `REGISTRATION_CHECK_` variables
    const step =
      [1, 1, 2, 2, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4][statusChecksCount] ?? 5

    return {
      title: t('confirm_title'),
      message: t('waiting_email_confirmation_reason_message', {
        reason: defaultReason,
      }),
      text: t(`long_waiting_email_confirmation_message_${step}`),
      buttonText: t(`waiting_email_confirmation_message`),
    }
  }
)

export const $verifyFormTranslation = combine(
  { i18n: i18n.$t, verificationType: $verificationTypeTranslation },
  ({ i18n: { t }, verificationType }) => {
    return {
      back: t('back'),
      title: t('account_verify'),
      description: t('email_code_verify_message', {
        email: verificationType,
      }),
      lockedButton: t('signing_in'),
      verifyButton: t('verify_continue'),
      verifyFooter: t('code_verify_footer'),
      verifyPhoneFooter: t('use_latest_sms_code_message'),
    }
  }
)

export const $inputVerifyFormTranslation = combine(i18n.$t, ({ t }) => {
  return {
    codeExpired: t('code_expired_error'),
    placeholder: t('enter_email_code'),
    label: t('code'),
    errors: {
      required: t('email_code_required_error'),
      digits: t('email_code_symbols_error'),
      maxLength: t('email_code_length_error'),
      minLength: t('email_code_length_error'),
    },
  }
})
